import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Login } from './Login';
import { SignUp } from './SignUp';

export const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(false); // Default to sign up

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      {/* Header with Branding */}
      <div className="navbar bg-base-100 shadow-lg">
        <div className="navbar-start">
          <Link to="/" className="btn btn-ghost text-xl">SuprHR</Link>
        </div>
        <div className="navbar-end">
          <Link to="/" className="btn btn-ghost">← Back to Home</Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Auth Type Toggle */}
          <div className="tabs tabs-boxed mb-6 bg-base-100 w-full">
            <button 
              className={`tab flex-1 ${!isLogin ? 'tab-active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Sign Up
            </button>
            <button 
              className={`tab flex-1 ${isLogin ? 'tab-active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Sign In
            </button>
          </div>
          
          {isLogin ? (
            <Login onSwitchToSignUp={() => setIsLogin(false)} />
          ) : (
            <SignUp onSwitchToSignIn={() => setIsLogin(true)} />
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="footer footer-center p-6 bg-base-300 text-base-content">
        <div>
          <div className="grid grid-flow-col gap-4 text-sm">
            <Link to="/terms" className="link link-hover">Terms of Use</Link>
            <Link to="/privacy" className="link link-hover">Privacy Policy</Link>
            <Link to="/contact" className="link link-hover">Contact</Link>
          </div>
          <p className="text-sm">Copyright © 2025 - All rights reserved by SuprHR</p>
        </div>
      </footer>
    </div>
  );
}; 